// @flow
import * as React from "react";
import { connect, type MapStateToProps } from "react-redux";
import { withRouter, type RouterHistory } from "react-router-dom";
import idx from "idx";
import Gettext from "../common/Gettext";
import { get } from "../common/fetch";
import { Button, Spinner } from "./Item";

import type { State as ReduxState } from "../../redux/reducer";
import type { Account, Profile } from "../../redux/CommonTypes";
import type { Dispatch } from "../../redux/action";

type Props = {
  onClick: () => void,
  dispatch: Dispatch,
  history: RouterHistory,
  accounts: Array<Account>,
  profile: Profile
};

type State = {
  fetching: boolean
};

class ButtonTradeReal extends React.Component<Props, State> {
  state = {
    fetching: false
  };

  refreshProfile = () => {
    return get("/api/profile").then(payload => {
      this.props.dispatch({ type: "RECEIVE_PROFILE", payload });
      return payload;
    });
  };

  closeAndRedirect = (redirect: string = "/trade") => {
    const { onClick } = this.props;

    this.setState({ fetching: false });
    if (onClick) onClick();
    this.props.history.push(redirect);
  };

  toggleRealAccount = () => {
    this.setState({ fetching: true });

    const { accounts, profile } = this.props;

    const account = idx(
      accounts.find(account => account.type === "real"),
      account => account.id
    );
    const active_account = idx(profile, profile => profile.active_account_id);

    if (account != null) {
      if (account === active_account) {
        // we don't need no setAccount
        this.closeAndRedirect("/trade");
        return;
      }

      get(`/ajax/setAccount?id=${account}`)
        .then(data => data.status === "OK" && this.refreshProfile())
        .then(data => {
          this.props.dispatch({ type: "SWITCH_ACCOUNTS" });
          this.closeAndRedirect("/trade");
        })
        .catch(error => error);

      return;
    }

    // if, somehow, real account is not present, which should not be possible
    this.closeAndRedirect("/fillup");
  };

  render() {
    return (
      <Button
        type="trade"
        onClick={this.toggleRealAccount}
        disabled={this.state.fetching}
      >
        {this.state.fetching ? <Spinner /> : <Gettext>Trade</Gettext>}
      </Button>
    );
  }
}

const mapStateToProps: MapStateToProps<*, *, *> = (state: ReduxState) => ({
  profile: state.profile,
  accounts: state.accounts
});

export default withRouter(connect(mapStateToProps)(ButtonTradeReal));



// WEBPACK FOOTER //
// ./src/components/Bell/ButtonTradeReal.js